export const localStorageItems = {
  enableMsw: 'mock:enable',
} as const;
